import { Spinner } from '@packages/ui/base/spinner/spinner';

/**
 * A full page loading screen.
 *
 * Use if a local loading state does not make sense from a UX perspective.
 * Inlcudes the full PageLayout but disables snowfall as the UI is loading.
 */
export const LoadingPage = () => {
  return (
    <div className="bg-primary-gradient text-primary-foreground flex h-screen flex-col items-center justify-center px-4">
      <Spinner />
    </div>
  );
};
